import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';

import { InsuranceCategoryRemoteSelector } from '../../InsurancePolicies';
import DropzoneFileSection from '../../Shared/DropzoneFileSection';
import { BasicTextArea, FormikDatePicker, FormikInput, FormikNumberFormat } from '../../Utils/Input';
import CurrencySelect from '../../../screens/InsurancePolicy/InsurancePoliciesForms/CurrencySelect';

const CoverSection = ({ action, modelName, requiredValues, fromAdmin, disabled }) => {
  const { errors, touched, values } = useFormikContext();
  const currency = values[`${modelName}`]?.currency ?? 'UF';

  const modelValues = values[`${modelName}`];
  const { additionalDocumentsInfo, coverAmount, estimatedNetPrime, estimatedNetCommission } = modelValues;

  return (
    <section className="form-section mb-5 w-100">
      {action !== 'edit' && <p className="section-title">Información de cobertura</p>}
      <Row>
        <Col lg={6} md={6}>
          <Field name={`${modelName}[insuranceCategoryId]`}>
            {({ field }) => <InsuranceCategoryRemoteSelector field={field} modelName={modelName} disabled={disabled} />}
          </Field>
        </Col>
        <Col md={6} lg={6}>
          <Field name={`${modelName}[currency]`}>
            {({ field }) => <CurrencySelect field={field} disabled={disabled} />}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col md={6} lg={fromAdmin ? 3 : 6}>
          <Field name={`${modelName}[parsedCoverAmount]`}>
            {({ field }) => (
              <FormikNumberFormat
                {...field}
                label="Monto cobertura"
                disabled={disabled}
                suffix={` ${currency}`}
                defaultValue={coverAmount}
                fieldName={`${modelName}[coverAmount]`}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>

        {fromAdmin && (
          <>
            <Col md={6} lg={3}>
              <Field name={`${modelName}[parsedEstimatedNetPrime]`}>
                {({ field }) => (
                  <FormikNumberFormat
                    {...field}
                    label="Prima neta estimada"
                    suffix={` ${currency}`}
                    defaultValue={estimatedNetPrime}
                    fieldName={`${modelName}[estimatedNetPrime]`}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={6} lg={3}>
              <Field name={`${modelName}[parsedEstimatedNetCommission]`}>
                {({ field }) => (
                  <FormikNumberFormat
                    {...field}
                    label="Comisión neta estimada"
                    suffix={` ${currency}`}
                    defaultValue={estimatedNetCommission}
                    fieldName={`${modelName}[estimatedNetCommission]`}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
          </>
        )}
        <Col md={6} lg={fromAdmin ? 3 : 6}>
          <Field name={`${modelName}[validityStart]`}>
            {({ field }) => (
              <FormikDatePicker
                {...field}
                label="Inicio vigencia"
                disabled={disabled}
                placeholder="dd/mm/aaaa"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col lg={6}>
          <Field name={`${modelName}[subjectMatter]`}>
            {({ field }) => (
              <BasicTextArea
                {...field}
                abbr
                label="Materia"
                placeholder="Escribe todos los detalles críticos de la materia asegurable que nos permitan cotizar con las compañías de seguro"
                tooltipText="Ejemplo: patente, material de construcción, metros cuadrados, año elaboración, etc."
                rows={2}
                className="p-3"
                disabled={disabled}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col lg={6}>
          <Field name={`${modelName}[subjectMatterAddress]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                label="Dirección del riesgo"
                placeholder="Nombre calle, num"
                disabled={disabled}
                touched={getIn(touched, field.name)}
                error={getIn(errors, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field name={`${modelName}[coverDetail]`}>
            {({ field }) => (
              <BasicTextArea
                {...field}
                abbr={requiredValues}
                label="Detalle de cobertura"
                placeholder="Escribe todos los detalles necesarios para el momento de cotizar este seguro en particular"
                rows={2}
                tooltipText="Ejemplo: prima deseada (si aplica), deducibles, preferencia de compañías aseguradoras, etc."
                className="p-3"
                disabled={disabled}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <DropzoneFileSection
        multiple
        disabled={disabled}
        label="Documentos adicionales"
        modelName="lead"
        originalObject={modelValues}
        persistedFiles={additionalDocumentsInfo}
      />
    </section>
  );
};

export default CoverSection;
